// 为现有弹窗统一补齐焦点圈定、Escape关闭、滚动锁定与关闭后焦点恢复。
export function installModalAccessibility(root = document.body) {
  const focusable = 'button:not(:disabled),a[href],input:not(:disabled),select:not(:disabled),textarea:not(:disabled),[tabindex]:not([tabindex="-1"])'
  let current = null, previousFocus = null, originalOverflow = '', locked = false
  const visible = node => node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden'
  function synchronize() {
    const dialogs = [...root.querySelectorAll('.modal-backdrop')].filter(visible)
    const backdrop = dialogs.at(-1)
    const dialog = backdrop?.querySelector('[role="dialog"]') || backdrop?.firstElementChild
    if (dialog === current) return
    if (dialog) {
      if (!locked) { previousFocus = document.activeElement; originalOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; locked = true }
      current = dialog
      dialog.setAttribute('role', 'dialog'); dialog.setAttribute('aria-modal', 'true')
      if (!dialog.hasAttribute('aria-label') && !dialog.hasAttribute('aria-labelledby')) dialog.setAttribute('aria-label', dialog.querySelector('h1,h2,h3')?.textContent?.trim() || '操作弹窗')
      if (!dialog.hasAttribute('tabindex')) dialog.setAttribute('tabindex', '-1')
      if (!dialog.contains(document.activeElement)) (dialog.querySelector('[autofocus]') || [...dialog.querySelectorAll(focusable)].find(visible) || dialog).focus()
    } else {
      current = null
      if (locked) { document.body.style.overflow = originalOverflow; locked = false; if (previousFocus?.isConnected) previousFocus.focus(); previousFocus = null }
    }
  }
  function onKey(event) {
    if (!current) return
    if (event.key === 'Escape') {
      const close = current.querySelector('.modal-close:not(:disabled)')
      if (close) { event.preventDefault(); event.stopPropagation(); close.click() }
      return
    }
    if (event.key !== 'Tab') return
    const nodes = [...current.querySelectorAll(focusable)].filter(visible)
    const first = nodes[0], last = nodes.at(-1)
    if (!first) { event.preventDefault(); current.focus(); return }
    if (!current.contains(document.activeElement) || (event.shiftKey && (document.activeElement === first || document.activeElement === current))) { event.preventDefault(); (event.shiftKey ? last : first).focus() }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus() }
  }
  const observer = new MutationObserver(synchronize)
  observer.observe(root, { childList:true, subtree:true })
  document.addEventListener('keydown', onKey, true)
  synchronize()
  return () => { observer.disconnect(); document.removeEventListener('keydown', onKey, true); if (locked) document.body.style.overflow = originalOverflow }
}
